module.exports = __webpack_public_path__ + "resources/img/img_dsm2.fdbd4deca2b448dbc715b51e6ad34b50.png";